<template>
  <span
    v-b-tooltip.hover.top="description || ''"
    class="tag-badge-wrap"
    :style="wrapperStyle"
    v-bind="description ? { tabindex: 0 } : {}"
  >
    <span
      class="tag-badge"
      :style="badgeStyle"
    >
      {{ name }}
      <span
        class="tag-hole"
        aria-hidden="true"
      />
    </span>
  </span>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'

export default {
  name: 'TagBadge',
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: '#000000',
    },
    description: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'small',
    },
    rotate: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    badgeStyle() {
      return {
        backgroundColor: this.color || '#000',
        '--tag-bg': this.color || '#000',
        color: '#ffffff',
        padding: this.size === 'small' ? '0.28rem 0.6rem' : '0.45rem 0.85rem',
        paddingLeft: this.size === 'small' ? '1.6rem' : '1.9rem',
        borderRadius: '6px',
        display: 'inline-block',
        fontSize: this.size === 'small' ? '0.85rem' : '1rem',
        fontWeight: 600,
        position: 'relative',
        boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
        transformOrigin: 'center center',
      }
    },
    wrapperStyle() {
      // rotate negative to tilt left like a clothing tag
      return {
        display: 'inline-block',
        transform: `rotate(-${this.rotate}deg)`,
        transformOrigin: 'center center',
      }
    },
  },
}
</script>

<style scoped>
.tag-badge-wrap {
  /* ensure layout doesn't collapse when rotated */
  line-height: 1;
  cursor: pointer;
}

.tag-badge {
  line-height: 1;
  vertical-align: middle;
  user-select: none;
  position: relative;
  z-index: 1;
}

.tag-hole {
  position: absolute;
  /* place near the left/top corner so it reads as a tag grommet */
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.32) inset;
  border: 2px solid rgba(0, 0, 0, 0.08);
  z-index: 2;
}

.tag-hole:after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  background: rgba(0, 0, 0, 0.01);
  border-radius: 50%;
}

/* triangular left edge */
.tag-badge:before {
  content: "";
  position: absolute;
  left: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 12px solid var(--tag-bg);
  z-index: 0;
}
</style>
